import { Location } from "react-router-dom";

export function locationStateWithEmail(location: Location, email: string): any {
  return { ...(location.state || {}), email };
}

export function getEmailFromLocation(location: Location): string {
  return location.state?.email ? (location.state.email as string) : "";
}

export function locationStateWithPrevious(location: Location): any {
  return { from: location };
}

export function getPreviousRelativeUrlFromLocation(
  location: Location
): string | null {
  const previousLocation = location.state?.from as Location | undefined;
  return previousLocation ? getRelativeUrlFromLocation(previousLocation) : null;
}

function getRelativeUrlFromLocation(location: Location): string {
  const { pathname, search, hash } = location;
  return `${pathname}${search}${hash}`;
}
